import React, { useContext } from "react";
import { IdentityContext } from "../contexts/IdentityProvider";
import PageConfig from "../utils/PageConfig";
import { SitewidePromoBar } from "@vp/sitewide-promo-bar";
import { TrackingConfiguration } from "@vp/sitewide-promo-bar/build/types";
import { Hidden, useScreenClass } from "@vp/swan";
import { useExperimentsContext } from "../contexts/ExperimentsProvider";
import {
  PDP_MOBILE_PROMO_BAR_EXPERIMENT_CONTEXT,
  PDP_MOBILE_PROMO_BAR_EXPERIMENT_TEST_VARIATION,
} from "../utils/abTests/abTests";
import { getScreenClass } from "../utils/screenClass";

export interface PromoBarContainerProps {
  locale: string;
  trackingConfiguration: TrackingConfiguration;
  promoBarConfig: React.ComponentProps<typeof SitewidePromoBar>["promoBarConfig"];
}

export const PromoBarContainer = (props: PromoBarContainerProps) => {
  const { trackingConfiguration, locale, promoBarConfig } = props;

  const { useExperiment } = useExperimentsContext();
  const { isMobile } = getScreenClass(useScreenClass());
  const { auth } = useContext(IdentityContext);

  const promoBarVariation = isMobile
    ? useExperiment(PDP_MOBILE_PROMO_BAR_EXPERIMENT_CONTEXT)
    : undefined;

  return promoBarVariation === PDP_MOBILE_PROMO_BAR_EXPERIMENT_TEST_VARIATION ? (
    <SitewidePromoBar
      tenant={PageConfig.tenant}
      locale={locale}
      promoBarConfig={promoBarConfig}
      canonicalId={auth?.getCanonicalId() ?? ""}
      pageType={"productPage"}
      trackingConfiguration={trackingConfiguration}
    />
  ) : (
    <Hidden xs>
      <SitewidePromoBar
        tenant={PageConfig.tenant}
        locale={locale}
        promoBarConfig={promoBarConfig}
        canonicalId={auth?.getCanonicalId() ?? ""}
        pageType={"productPage"}
        trackingConfiguration={trackingConfiguration}
      />
    </Hidden>
  );
};

export default PromoBarContainer;
